<div class="bmc-ai-jobs">
  <h5 class="bz-space--stack-m">{{'USERJOBS.DESCRIPTION' | translate}}</h5>
  <div *ngIf="!areThereUserJobs() && !isLoadingJobs" class="bmc-ai-jobs__empty-list">
      <h3>{{'USERJOBS.NO_JOBS_TITLE' | translate}}</h3>
      <h4>{{'USERJOBS.NO_JOBS_SUBTITLE' | translate}}</h4>
  </div>
  <div class="bmc-ai-jobs__loading-container" *ngIf="isLoadingJobs">
    <bz-loading [size]="'m'" class="bmc-ai-jobs__loading">
      {{ 'GLOBAL.LOADING_DATA' | translate }}</bz-loading>
  </div>
  <bzg-tab-set *ngIf="areThereUserJobs()" class="bmc-ai-jobs__container" (onSelectTab)="selectedTab = $event.index">
    <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'AIJOBS.WAITINGS_AIJOBS' | translate | uppercase}}">
        <ai-jobs-wrapper [userJobs]="waitingUserJobs" (resetEmit)="getAllData()"></ai-jobs-wrapper>
    </bzg-tab-item>
    <!-- <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'AIJOBS.EXECUTED_AIJOBS' | translate | uppercase}}">      
        <ai-jobs-wrapper [userJobs]="executedUserJobs" (resetEmit)="getAllData()"></ai-jobs-wrapper>         
    </bzg-tab-item> -->
  </bzg-tab-set>
</div>